import '../styles/index.scss';

/* global AFRAME, THREE */
if (typeof AFRAME === 'undefined') {
  throw new Error('Component attempted to register before AFRAME was available.');
}

var TIMESTAMP = null;
var WALKING = false;

const fireKey = (keycode,keyname,fn1,fn2) => {
  if (document.createEventObject) {
    var eventObj = document.createEventObject();
    eventObj.keyCode = keycode;
    document.fireEvent(fn1, eventObj);
    eventObj.keyCode = keycode;   
  } else if (document.createEvent) {
    var eventObj = document.createEvent("Events");
    eventObj.initEvent(fn2, true, true);
    eventObj.key=keyname;    // just enter the char you want to send 
    eventObj.keyCode=eventObj.key.charCodeAt(keycode);
    eventObj.which=eventObj.keyCode;
    eventObj.altKey=false;
    eventObj.ctrlKey=true;
    eventObj.shiftKey=false;
    eventObj.metaKey=false;
//    eventObj.bubbles=true;
    document.dispatchEvent(eventObj);
  }
}; 

window.addEventListener("mousedown", event => {
  if (TIMESTAMP == null || TIMESTAMP + 100 < event.timeStamp) {
		fireKey(38,"ArrowUp","onkeydown","keydown"); 
		console.log("mouse trigger startWalking");
		TIMESTAMP = event.timeStamp;
  }
});

window.addEventListener("mouseup", event => {
  if (TIMESTAMP == null || TIMESTAMP + 100 < event.timeStamp) {
		fireKey(38,"ArrowUp","onkeyup","keyup"); 
		console.log("mouse trigger stopWalking");
		TIMESTAMP = event.timeStamp;
  }
});

window.addEventListener("keydown", event => {
	if (event.defaultPrevented) {
		return; // Do nothing if the event was already processed
	}
	if (event.key == "ArrowUp" && !WALKING) {
		console.log('key startWalking');
		WALKING = true;
	}
  	
	// Cancel the default action to avoid it being handled twice
	event.preventDefault();
}, true);

window.addEventListener("keyup", event => {
	if (event.defaultPrevented) {
  	return; // Do nothing if the event was already processed
	}
	if (event.key == "ArrowUp") {
	console.log('key stopWalking');
	WALKING = false;
	}

	// Cancel the default action to avoid it being handled twice
	event.preventDefault();
}, true);


// Converts userheight for basemesh obj.
var userHeightConvert = function(height) {
	return height/1.6 * 0.95;
};

//Component rotating on the Y-axes with the camera.
AFRAME.registerComponent('avatar', {
	schema: {
		obj: {default: 'assets/models/avatar.glb'},
		offsetPos: { type: 'vec3', default: {x:0, y:0, z:0} },
	},
  init: function () { 
		var data = this.data;
		var el = this.el;
		var _this = this;
		var userHeight = 1.6; 

    var avatarContainer = avatarContainer = document.createElement("a-entity");
    avatarContainer.setAttribute('geometry', `primitive: box; width: 1; height: ${userHeight}; depth:1;`);
    avatarContainer.setAttribute('material', 'shader: flat; opacity: 0; color: #fff');
    avatarContainer.setAttribute('position', `0 ${userHeight/2} 0`);
    avatarContainer.setAttribute('rotation', '0 0 0');
    el.appendChild(avatarContainer);

    var avatarModel = document.createElement("a-entity");
    avatarModel.setAttribute('gltf-model', data.obj);
    avatarModel.setAttribute('position', `${data.offsetPos.x} -${userHeight/2} ${data.offsetPos.z}`);
    avatarModel.setAttribute('rotation', '0 180 0');
    avatarModel.setAttribute('scale', `1  ${userHeightConvert(userHeight)} 1`);
    //avatarContainer.appendChild(avatarModel);

    var avatarboundary = document.createElement("a-entity");
    avatarboundary.setAttribute('geometry', 'primitive: ring; radiusInner: 0.26; radiusOuter:0.28; segmentsRadial:18; thetaStart:80; thetaLength:20;');
    avatarboundary.setAttribute('material', 'shader: flat; opacity: 0.75; color: red');
    avatarboundary.setAttribute('rotation', '-90 0 0');
    avatarboundary.setAttribute('position', `0 -${(userHeight/2)-0.01} 0`);
    avatarContainer.appendChild(avatarboundary);

  },
  tick: function () {
    const cameraEl = this.el.sceneEl.camera.el.object3D;
    let yRot = (Math.round(THREE.Math.radToDeg(cameraEl.rotation._y) * 100) / 100);
    this.el.setAttribute("rotation", "0 " + yRot + " 0");
  }
});

//Component visualization of clock rotation
AFRAME.registerComponent('orientation', {
  	init: function () { 
		var el = this.el;
		var userHeight = 1.6; 

		var clockBase = document.createElement("a-entity");
		clockBase.setAttribute('geometry', 'primitive: ring; radiusInner: 0.29; radiusOuter:0.31; segmentsRadial:18;');
		clockBase.setAttribute('material', 'shader: flat; opacity: 0.5; color: black');
		clockBase.setAttribute('rotation', '-90 0 0');
		clockBase.setAttribute('position', '0 0.01 0');
		el.appendChild(clockBase);

		var t0 = document.createElement("a-entity");
		t0.setAttribute('geometry', 'primitive: plane; width: 0.01; height: 0.01');
		t0.setAttribute('material', 'shader: flat; opacity: 1; color: white');
		t0.setAttribute('rotation', '0 0 0');
		clockBase.appendChild(t0);
		var t1 = document.createElement("a-entity");
		t1.setAttribute('geometry', 'primitive: plane; width: 0.01; height: 0.01');
		t1.setAttribute('material', 'shader: flat; opacity: 1; color: white');
		t1.setAttribute('rotation', '0 0 -30');
		clockBase.appendChild(t1);
		var t2 = document.createElement("a-entity");
		t2.setAttribute('geometry', 'primitive: plane; width: 0.01; height: 0.01');
		t2.setAttribute('material', 'shader: flat; opacity: 1; color: white');
		t2.setAttribute('rotation', '0 0 -60');
		clockBase.appendChild(t2);
		var t3 = document.createElement("a-entity");
		t3.setAttribute('geometry', 'primitive: plane; width: 0.01; height: 0.01');
		t3.setAttribute('material', 'shader: flat; opacity: 1; color: white');
		t3.setAttribute('rotation', '0 0 -90');
		clockBase.appendChild(t3);
		var t4 = document.createElement("a-entity");
		t4.setAttribute('geometry', 'primitive: plane; width: 0.01; height: 0.01');
		t4.setAttribute('material', 'shader: flat; opacity: 1; color: white');
		t4.setAttribute('rotation', '0 0 -120');
		clockBase.appendChild(t4);
		var t5 = document.createElement("a-entity");
		t5.setAttribute('geometry', 'primitive: plane; width: 0.01; height: 0.01');
		t5.setAttribute('material', 'shader: flat; opacity: 1; color: white');
		t5.setAttribute('rotation', '0 0 -150');
		clockBase.appendChild(t5);
		var t6 = document.createElement("a-entity");
		t6.setAttribute('geometry', 'primitive: plane; width: 0.01; height: 0.01');
		t6.setAttribute('material', 'shader: flat; opacity: 1; color: white');
		t6.setAttribute('rotation', '0 0 -180');
		clockBase.appendChild(t6);
		var t7 = document.createElement("a-entity");
		t7.setAttribute('geometry', 'primitive: plane; width: 0.01; height: 0.01');
		t7.setAttribute('material', 'shader: flat; opacity: 1; color: white');
		t7.setAttribute('rotation', '0 0 -210');
		clockBase.appendChild(t7);
		var t8 = document.createElement("a-entity");
		t8.setAttribute('geometry', 'primitive: plane; width: 0.01; height: 0.01');
		t8.setAttribute('material', 'shader: flat; opacity: 1; color: white');
		t8.setAttribute('rotation', '0 0 -240');
		clockBase.appendChild(t8);
		var t9 = document.createElement("a-entity");
		t9.setAttribute('geometry', 'primitive: plane; width: 0.01; height: 0.01');
		t9.setAttribute('material', 'shader: flat; opacity: 1; color: white');
		t9.setAttribute('rotation', '0 0 -270');
		clockBase.appendChild(t9);
		var t10 = document.createElement("a-entity");
		t10.setAttribute('geometry', 'primitive: plane; width: 0.01; height: 0.01');
		t10.setAttribute('material', 'shader: flat; opacity: 1; color: white');
		t10.setAttribute('rotation', '0 0 -300');
		clockBase.appendChild(t10);
		var t11 = document.createElement("a-entity");
		t11.setAttribute('geometry', 'primitive: plane; width: 0.01; height: 0.01');
		t11.setAttribute('material', 'shader: flat; opacity: 1; color: white');
		t11.setAttribute('rotation', '0 0 -330');
		clockBase.appendChild(t11);

		var time0 = document.createElement("a-entity");
		time0.setAttribute('geometry', 'primitive: plane; width: auto; height: 0.01');
		time0.setAttribute('material', 'shader: flat; opacity: 0; color: white');
		time0.setAttribute('text', 'color: #000; align: center; value: [12]; ');
		time0.setAttribute('position', '0 0.35 0.01');
		t0.appendChild(time0);

		var time1 = document.createElement("a-entity");
		time1.setAttribute('geometry', 'primitive: plane; width: auto; height: 0.1');
		time1.setAttribute('material', 'shader: flat; opacity: 0; color: white');
		time1.setAttribute('text', 'color: #000; align: center; value: [1]; ');
		time1.setAttribute('position', '0 0.35 0.01');
		t1.appendChild(time1);

		var time2 = document.createElement("a-entity");
		time2.setAttribute('geometry', 'primitive: plane; width: auto; height: 0.1');
		time2.setAttribute('material', 'shader: flat; opacity: 0; color: white');
		time2.setAttribute('text', 'color: #000; align: center; value: [2]; ');
		time2.setAttribute('position', '0 0.35 0.01');
		t2.appendChild(time2);

		var time3 = document.createElement("a-entity");
		time3.setAttribute('geometry', 'primitive: plane; width: auto; height: 0.1');
		time3.setAttribute('material', 'shader: flat; opacity: 0; color: white');
		time3.setAttribute('text', 'color: #000; align: center; value: [3]; ');
		time3.setAttribute('position', '0 0.35 0.01');
		t3.appendChild(time3);

		var time4 = document.createElement("a-entity");
		time4.setAttribute('geometry', 'primitive: plane; width: auto; height: 0.1');
		time4.setAttribute('material', 'shader: flat; opacity: 0; color: white');
		time4.setAttribute('text', 'color: #000; align: center; value: [4]; ');
		time4.setAttribute('position', '0 0.35 0.01');
		t4.appendChild(time4);

		var time5 = document.createElement("a-entity");
		time5.setAttribute('geometry', 'primitive: plane; width: auto; height: 0.1');
		time5.setAttribute('material', 'shader: flat; opacity: 0; color: white');
		time5.setAttribute('text', 'color: #000; align: center; value: [5]; ');
		time5.setAttribute('position', '0 0.35 0.01');
		t5.appendChild(time5);

		var time6 = document.createElement("a-entity");
		time6.setAttribute('geometry', 'primitive: plane; width: auto; height: 0.1');
		time6.setAttribute('material', 'shader: flat; opacity: 0; color: white');
		time6.setAttribute('text', 'color: #000; align: center; value: [6]; ');
		time6.setAttribute('position', '0 0.35 0.01');
		t6.appendChild(time6);

		var time7 = document.createElement("a-entity");
		time7.setAttribute('geometry', 'primitive: plane; width: auto; height: 0.1');
		time7.setAttribute('material', 'shader: flat; opacity: 0; color: white');
		time7.setAttribute('text', 'color: #000; align: center; value: [7]; ');
		time7.setAttribute('position', '0 0.35 0.01');
		t7.appendChild(time7);

		var time8 = document.createElement("a-entity");
		time8.setAttribute('geometry', 'primitive: plane; width: auto; height: 0.1');
		time8.setAttribute('material', 'shader: flat; opacity: 0; color: white');
		time8.setAttribute('text', 'color: #000; align: center; value: [8]; ');
		time8.setAttribute('position', '0 0.35 0.01');
		t8.appendChild(time8);

		var time9 = document.createElement("a-entity");
		time9.setAttribute('geometry', 'primitive: plane; width: auto; height: 0.1');
		time9.setAttribute('material', 'shader: flat; opacity: 0; color: white');
		time9.setAttribute('text', 'color: #000; align: center; value: [9]; ');
		time9.setAttribute('position', '0 0.35 0.01');
		t9.appendChild(time9);

		var time10 = document.createElement("a-entity");
		time10.setAttribute('geometry', 'primitive: plane; width: auto; height: 0.1');
		time10.setAttribute('material', 'shader: flat; opacity: 0; color: white');
		time10.setAttribute('text', 'color: #000; align: center; value: [10]; ');
		time10.setAttribute('position', '0 0.35 0.01');
		t10.appendChild(time10);

		var time11 = document.createElement("a-entity");
		time11.setAttribute('geometry', 'primitive: plane; width: auto; height: 0.1');
		time11.setAttribute('material', 'shader: flat; opacity: 0; color: white');
		time11.setAttribute('text', 'color: #000; align: center; value: [11]; ');
		time11.setAttribute('position', '0 0.35 0.01');
		t11.appendChild(time11);


  }
});


AFRAME.registerComponent('aps', {
  	init: function () { 
		var data = this.data;
		var el = this.el;

		var apsBase = document.createElement("a-entity");
		apsBase.setAttribute('geometry', `primitive: box; width: 0.04; height: 0.35; depth: 0.12;`);
		apsBase.setAttribute('material', `color: yellow;`);
		apsBase.setAttribute('position', '0 0 0');
		el.appendChild(apsBase);

		var button = document.createElement("a-entity");
		button.setAttribute('geometry', `primitive: cylinder; radius: 0.048; height: 0.02;`);
		button.setAttribute('material', `color: #111; opacity:1`);
		button.setAttribute('position', '0.03 -0.085 0');
		button.setAttribute('rotation', '90 90 0');
		apsBase.appendChild(button);
	}

});

//Component emitting sound: soundspace="snd:#sound; falloff:1; maxdist:1; trigger:true"
AFRAME.registerComponent('soundspace', {
	schema: {
        snd: {type: 'string', default: ''},
        color: {type: 'string', default: 'blue'},
		vol: { type: 'number', default: 1 },
		rolloff: { type: 'number', default: 1 },
		maxdist: { type: 'number', default: 1 },
		trigger: { type: 'boolean', default: false },
		auto: { type: 'boolean', default: false },
		debug: { type: 'boolean', default: false },
		loop: { type: 'boolean', default: false }
	},
  	init: function () { 
		var data = this.data;
		var el = this.el;

        if(data.debug){
			var sphere = document.createElement("a-entity");
			sphere.setAttribute('geometry', `primitive: sphere; radius: ${data.maxdist}; segmentsHeight:6; segmentsWidth:12;`);
			sphere.setAttribute('material', `shader: flat; opacity: 1; color: ${data.color}; wireframe:true`);
			sphere.setAttribute('position', '0 0 0');
			el.appendChild(sphere);
		}

        if(data.snd != ''){
            el.setAttribute('sound', `src: ${data.snd}; poolSize:1; volume: ${data.vol}; maxDistance: ${data.maxdist}; rolloffFactor: ${data.rolloff}; loop:${data.loop}; autoplay:${data.auto}`);
        }

    }
});



AFRAME.registerComponent('lookatlabel', {
	init: function () {
		var el = this.el;
		el.setAttribute('material', `shader: flat; opacity:0; color:#000;`);
		var label = document.createElement("a-entity");
		label.setAttribute('geometry', 'primitive:plane; width:1.25; height:0.25;');
		label.setAttribute('text', `value:${this.data}; align:center; font:https://cdn.aframe.io/fonts/Aileron-Semibold.fnt; color:#fff;width:1.3;wrapCount:15;`);
		label.setAttribute('material', `color:#333; opacity:1;`);
		label.setAttribute('position', '0 1.2 0');
		label.setAttribute('rotation', '0 90 0');

		el.appendChild(label);		
		var labelBack = document.createElement("a-entity");
		labelBack.setAttribute('geometry', 'primitive:plane; width:1.25; height:0.25;');
		labelBack.setAttribute('text', `value:${this.data}; align:center; font:https://cdn.aframe.io/fonts/Aileron-Semibold.fnt; color:#fff;width:1.3;wrapCount:15;`);
		labelBack.setAttribute('material', `color:#333; opacity:1;`);
		labelBack.setAttribute('position', '0 1.2 0');
		labelBack.setAttribute('rotation', '0 -90 0');
		el.appendChild(labelBack);		

	}
});

window.onload = function() {

//		el.appendChild(btn);		
	//	console.log("hi ther");
		
};
// Controls for UI
AFRAME.registerComponent('a11y-control', {
	init: function () {
		var el = this.el.sceneEl;
		var btn = document.createElement("a");
		btn.setAttribute("href","#");
		btn.setAttribute("role","button");
		btn.innerText="Load Sim 1";
		console.log("is this loading");
	
		el.appendChild(btn);		
		console.log("hi ther");
		var sim2 = document.querySelector("#sim2");
		console.log("here");
		console.log(sim2);
		sim2.setAttribute("role","link");

	}
});


AFRAME.registerComponent('log', {
	dependencies: ['a-gui-button'],
  schema: {type: 'string'},

  init: function () {
    var stringToLog = this.data;
		console.log(stringToLog);
		

		var sim2 = document.querySelector("#sim2");
		console.log("here");
		console.log(sim2);
		sim2.setAttribute("role","link");
		var gc = document.querySelector("#grpCommands");
		gc.setAttribute("role","group");
  }
});